import { fetchApi } from '@/config/axiosSetting';
import { PatchAdjusterOtherDamagedDescriptionQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchAdjusterOtherDamagedDescription/patchAdjusterOtherDamagedDescriptionQuery.type';
export const patchAdjusterOtherDamagedDescriptionFunction = (
  params: PatchAdjusterOtherDamagedDescriptionQueryParamsType,
): Promise<{}> => {
  const data = new FormData();
  data.append(
    'other_damaged_description',
    params.data.other_damaged_description,
  );
  return fetchApi({
    method: 'PATCH',
    url: `property/reports/${params.id}/accident_users/damaged/customer/other_damaged/description/`,
    data,
    params: { damaged_id: params.damagedId },
  });
};
